export function publicLeagueSlug(slug: string | null | undefined) {
  if (!slug) return "premier-league";
  return slug === "bajnokok-ligaja" ? "champions-league" : slug;
}

export function dbLeagueSlug(slug: string) {
  return slug === "champions-league" ? "bajnokok-ligaja" : slug;
}

export function leagueHref(slug: string | null | undefined) {
  return `/${publicLeagueSlug(slug)}`;
}

export function teamHref(leagueSlug: string | null | undefined, teamSlug: string) {
  return `${leagueHref(leagueSlug)}/${teamSlug}`;
}

